@if(isLoading()){
<app-loader message="Chargement des données..." class="margin"></app-loader>
}
@else {
<div class="container">

  <!-- Champs de recherche -->
  <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
    <mat-label>Recherche par nom / prénom</mat-label>
    <input matInput type="text" [value]="searchSignal()" (input)="searchSignal.set($event.target.value)">
  </mat-form-field>

  @if(filteredEleves().length > 0){
  <!-- Liste des élèves -->
  @for (eleve of filteredEleves(); track $index) {
  <div class="section-admin-subtitle primary">
    @if(eleve.idAdulte !== 0){
    @if(eleve.sexe === "F"){
    <app-icon icon="woman" type="do"></app-icon>
    }@else {
    <app-icon icon="man" type="do"></app-icon>
    }
    }@else{
    @if(eleve.sexe === "F"){
    <app-icon icon="fille" type="do"></app-icon>
    }@else {
    <app-icon icon="garcon" type="do"></app-icon>
    }
    }
    {{eleve.nomReferent}}
  </div>
  <div class="fx-direction-row fx-wrap fx-gap-10">
    @if(eleve.idAdulte !== 0){
    <ng-container
      *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant}"></ng-container>
    }
    @if(eleve.idEnfant !== 0){
    @if(eleve.adulte1.nom && eleve.adulte1.prenom){
    <ng-container
      *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte1, idEnfant:eleve.idEnfant }"></ng-container>
    }
    @if(eleve.adulte2.nom && eleve.adulte2.prenom){
    <ng-container
      *ngTemplateOutlet="contactCardTemplate; context: { adulte: eleve.adulte2, idEnfant:eleve.idEnfant }"></ng-container>
    }
    }
  </div>

  <mat-divider style="margin-top: 20px;"></mat-divider>

  }
  }@else {
  <p class="section-admin-subtitle">Aucun élève trouvé.</p>
  }
</div>
}

<ng-template #contactCardTemplate let-adulte="adulte" let-idEnfant="idEnfant">
  <mat-card appearance="outlined" class="fx-flex-auto" style="padding: 6px;">
    <!-- Nom Prenom Responsable -->
    @if(idEnfant !== 0){
    <div style="font-size: smaller;">
      @if(adulte.sexe === "F"){
      <app-icon icon="woman" type="do" style="margin-right: 3px;"></app-icon>
      }@else {
      <app-icon icon="man" type="do" style="margin-right: 3px;"></app-icon>
      }
      <span>{{adulte.nom}} {{adulte.prenom}}</span>
    </div>
    }

    <!-- Adresse -->
    <span class="fx-direction-row fx-start-start fx-gap-3" style="margin-top: 5px;">
      <mat-icon>location_on</mat-icon>
      <div style="font-size: smaller;">
        @if(adulte.rue){
        <span>
          @if (adulte.numRue) {
          {{adulte.numRue}}
          }
          {{adulte.rue}}
          <br>
        </span>
        }
        @if(adulte.rue2){
        <span>
          {{adulte.rue2}}
          <br>
        </span>
        }
        @if(adulte.rue3){
        <span>
          {{adulte.rue3}}
          <br>
        </span>
        }
        @if(adulte.ville){
        <span>
          @if(adulte.codePostal){
          {{adulte.codePostal}}
          }
          {{adulte.ville}}
          <br>
        </span>
        }
      </div>
    </span>

    <!-- Téléphones -->
    <span class="fx-direction-row fx-start-start fx-gap-3" style="margin-top: 5px;">
      <mat-icon>phone_enabled</mat-icon>
      <div style="font-size: smaller;">
        @if(adulte.telMobile){
        <span>
          {{adulte.telMobile}}
          <br>
        </span>
        }
        @if(adulte.telephone){
        <span>
          {{adulte.telephone}}
          <br>
        </span>
        }
      </div>
    </span>

    <!-- Email -->
    @if(adulte.email){
    <div class="fx-direction-row fx-start-center fx-gap-3" style="margin-top: 5px;">
      <mat-icon>mail</mat-icon>
      <span style="font-size: smaller;">
        {{adulte.email}}
        <br>
      </span>
    </div>
    }
  </mat-card>
</ng-template>